import React from "react";
import { useHistory } from "react-router-dom";

const HeaderOpt = ({ event_list_params }) => {
  const history = useHistory();
  const isEvent = () =>
    history.location.pathname.includes("add_event") ||
    history.location.pathname.includes("edit");

  const handleEventClick = () => {
    if (isEvent()) {
      history.push("/outside_team_building");
    }
  };

  return (
    <div className="otp-header">
      <div className="breadcrumb-div">
        <span className="text-1 bread-crumb" onClick={() => history.push("/")}>
          Home
        </span>
        <span className="text-1">{` > `}</span>
        <span
          className={`text-1 ${isEvent() ? "bread-crumb" : ""}`}
          onClick={handleEventClick}
        >
          Events
        </span>
        {history.location.pathname.includes("add_event") && (
          <span className="text-1">{` > Create New`}</span>
        )}
        {history.location.pathname.includes("edit") && (
          <span className="text-1">{` > Edit`}</span>
        )}
      </div>
      <h1 className="heading">Outside Events</h1>
      <p className="info">
        Record, manage, and track all of your team building activities.{" "}
      </p>
    </div>
  );
};

export default HeaderOpt;
